import ThemifyIconsContainer from "../../Component/Icons/ThemifyIcons/ThemifyIcons"

const ThemifyIcons = () => {
  return (
    <div className='page-body'>
      <ThemifyIconsContainer />
    </div>
  )
}

export default ThemifyIcons